"use strict";

exports.__esModule = true;
exports.isServiceWithVariedPrice = exports.isServiceWithMultipleStaffMembers = exports.isServiceHasPreferencesSelection = exports.filterServicesBySelectionsAndConstrains = exports.canAutoAssignStaff = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
var _constants = require("../../constants");
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
const filterServicesBySelectionsAndConstrains = ({
  selectedLocation,
  services,
  constrains,
  selectedServicesPreferences
}) => {
  var _selectedServicesPref, _constrains$resources;
  const selectedStaffId = selectedServicesPreferences == null || (_selectedServicesPref = selectedServicesPreferences[0]) == null || (_selectedServicesPref = _selectedServicesPref.resources[_constants.STAFF_RESOURCE_GROUP_ID]) == null ? void 0 : _selectedServicesPref[0];
  const isSingleStaffSelection = constrains == null || (_constrains$resources = constrains.resources) == null ? void 0 : _constrains$resources[_constants.STAFF_RESOURCE_GROUP_ID].singleSelection;
  const filterFunctions = [filterByLocation(selectedLocation)];
  if (isSingleStaffSelection) {
    filterFunctions.push(filterByResource(selectedStaffId));
  }
  return services.filter(service => filterFunctions.every(filterFunction => filterFunction(service)));
};
exports.filterServicesBySelectionsAndConstrains = filterServicesBySelectionsAndConstrains;
const filterByResource = selectedResource => service => service.staffMembers.some(({
  staffMemberId
}) => selectedResource === staffMemberId);
const filterByLocation = selectedLocation => service => service.locations.some(serviceLocation => {
  if (serviceLocation.type === _types.LocationType.BUSINESS) {
    var _serviceLocation$busi;
    const businessLocationId = (_serviceLocation$busi = serviceLocation.business) == null ? void 0 : _serviceLocation$busi.id;
    return !businessLocationId && !selectedLocation.value || businessLocationId === selectedLocation.value;
  }
  if (serviceLocation.type === _types.LocationType.CUSTOM) {
    var _serviceLocation$cust;
    return ((_serviceLocation$cust = serviceLocation.custom) == null || (_serviceLocation$cust = _serviceLocation$cust.address) == null ? void 0 : _serviceLocation$cust.formattedAddress) === selectedLocation.value;
  }
  if (serviceLocation.type === _types.LocationType.CUSTOMER) {
    return selectedLocation.type === _types.LocationType.CUSTOMER;
  }
  return false;
});
const isServiceHasPreferencesSelection = ({
  service,
  excludeLocation = false,
  excludeResourceGroups = [],
  experiments
}) => {
  const {
    locations,
    staffMembers
  } = service;
  const {
    payment
  } = service;
  const shouldShowLocationSelector = !excludeLocation && (locations == null ? void 0 : locations.length) > 1;
  const shouldShowStaffSelector = !excludeResourceGroups.includes(_constants.STAFF_RESOURCE_GROUP_ID) && (staffMembers == null ? void 0 : staffMembers.length) > 1;
  const isVariedPrice = (payment == null ? void 0 : payment.rateType) === _types.RateType.VARIED;
  const isAppointmentWithAddOns = service.type === _types.ServiceType.APPOINTMENT && (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service, experiments);
  return shouldShowLocationSelector || shouldShowStaffSelector || isVariedPrice || isAppointmentWithAddOns;
};
exports.isServiceHasPreferencesSelection = isServiceHasPreferencesSelection;
const canAutoAssignStaff = service => {
  return isServiceWithMultipleStaffMembers(service);
};
exports.canAutoAssignStaff = canAutoAssignStaff;
const isServiceWithVariedPrice = service => {
  var _service$payment;
  return (service == null || (_service$payment = service.payment) == null ? void 0 : _service$payment.rateType) === _types.RateType.VARIED;
};
exports.isServiceWithVariedPrice = isServiceWithVariedPrice;
const isServiceWithMultipleStaffMembers = service => {
  var _service$staffMembers;
  return ((service == null || (_service$staffMembers = service.staffMembers) == null ? void 0 : _service$staffMembers.length) || 0) > 1;
};
exports.isServiceWithMultipleStaffMembers = isServiceWithMultipleStaffMembers;
//# sourceMappingURL=service.js.map